<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <router-link
                class="btn btn-outline-primary btn-sm mr-3"
                :to="{ name: 'all-services-cn' }"
                ><i class="fa fa-chevron-left mr-2"></i
                >{{ $t("message.back") }}</router-link
              >
              <h4 class="card-title">
                {{ $t("message.find_partner.court_notice_info") }}
              </h4>
            </div>
            <pdf
              v-if="searchComplete && response_info.VerifyResult == 1"
              :doc_additional="{ request: keyWord }"
              :user_id="0"
              :document="response_info"
              :goods="[]"
              :doc_id="0"
              source="court-info-service-cn"
            ></pdf>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <br />
                <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                  <input
                    type="text"
                    class="form-control"
                    id="keyword"
                    v-model="keyWord"
                    :placeholder="$t('message.find_partner.search_keyword')"
                    autocomplete="off"
                    style="cursor: auto"
                  />
                  <label for="keyword" class="form-label-group-label">{{
                    $t("message.find_partner.search_keyword")
                  }}</label>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <button
                  :class="[
                    'btn',
                    'btn-success',
                    'btn-round',
                    'btn-sm',
                    'position-relative',
                  ]"
                  @click="searchCompanyCourtInfo"
                  id="init_search_china"
                >
                  {{ $t("message.find_partner.search_button") }}
                </button>
              </div>
            </div>
            <br />
            <div
              v-if="!searchComplete && loading"
              style="position: relative; height: 100px"
            >
              <div class="loading"></div>
            </div>
            <div v-if="searchComplete && response_info.VerifyResult == 1">
              <div v-if="response_info.Data.length > 0">
                <div
                  class="card-header card-header-primary negative rounded-0 blue-grad w-50"
                >
                  <h4>{{ $t("message.find_partner.court_notice_info") }}</h4>
                </div>
                <br />
                <b-table
                  :fields="court_notice_list_fields"
                  :items="response_info.Data"
                >
                </b-table>
              </div>
              <div v-else class="p-3 text-center">
                {{ $t("message.find_partner.no_results") }}
              </div>
            </div>
            <div v-if="searchComplete && no_results">
              <div class="p-3 text-center">
                {{
                  $t("message.find_partner.no_results").replace(
                    "[company]",
                    keyWord,
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      current_tab: 0,
      loading: false,
      no_results: false,
      response_info: [],
      service_info: {},
      service_info_objects: {},
      keyWord: "",
      searchComplete: false,
      court_notice_list_fields: [
        {
          key: "Id",
          label: this.$t("message.find_partner.court_notice_Id"),
        },
        {
          key: "CaseNo",
          label: this.$t("message.find_partner.court_notice_CaseNo"),
        },
        {
          key: "CaseReason",
          label: this.$t("message.find_partner.court_notice_CaseReason"),
        },
        {
          key: "Category",
          label: this.$t("message.find_partner.court_notice_Category"),
        },
        {
          key: "Court",
          label: this.$t("message.find_partner.court_notice_Court"),
        },
        {
          key: "PublishDate",
          label: this.$t("message.find_partner.court_notice_PublishDate"),
        },
        {
          key: "ProsecutorList",
          label: this.$t("message.find_partner.court_notice_ProcecutorList"),
        },
        {
          key: "DefendantList",
          label: this.$t("message.find_partner.court_notice_DefendantList"),
        },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    translateTextArray(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
            "/library/TranslateNextArray?source=zh&target=" +
            locale,
          text,
        );
      }
    },
    formatArrayObjectTables(object, list) {
      if (typeof object !== undefined && object && object.length > 0) {
        object.forEach((obj, i) => {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          console.log("keys", keys);
          console.log("values", values);
          this.translateTextArray(values).then((res) => {
            var translated = {};
            for (let j = 0; j < res.data.length; j++) {
              translated[keys[j]] = JSON.parse(res.data[j]).translation;
              console.log("translated");
              console.log(translated);
            }
            list.push(translated);
          });
        });
        this.searchComplete = true;
        this.loading = false;
      }
    },
    searchCompanyCourtInfo() {
      axios
        .get(window.base + "/admin/GetBillingServiceInfo?code=930")
        .then((response) => {
          this.$bvModal
            .msgBoxConfirm(
              this.$t("message.find_partner.cn_company_info_check_alert") +
                " " +
                response.data.billing_service_price +
                " " +
                response.data.billing_service_cur,
              {
                title: this.$t("message.confirm"),
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.$t("message.yes"),
                cancelTitle: this.$t("message.no"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              },
            )
            .then((value) => {
              if (value) {
                this.loading = true;
                this.searchComplete = false;
                axios
                  .get(
                    "https://attistrade.cn/library/openAPICourt?keyWord=" +
                      this.keyWord,
                  )
                  .then((response) => {
                    if (
                      response.data.Result.VerifyResult == 1 &&
                      response.data.Result.Data.length > 0
                    ) {
                      this.no_results = false;
                      response.data.Result.Data.map((item) => {
                        if (item.ProsecutorList.length > 0) {
                          item.ProsecutorList = item.ProsecutorList.map(
                            (value) => {
                              return value.Name;
                            },
                          ).join(",");
                        }

                        if (item.DefendantList.length > 0) {
                          item.DefendantList = item.DefendantList.map(
                            (value) => {
                              return value.Name;
                            },
                          ).join(",");
                        }

                        return item;
                      });
                      var tmp = {};
                      tmp.Data = [];
                      this.formatArrayObjectTables(
                        response.data.Result.Data,
                        tmp.Data,
                      );
                      this.response_info = tmp;
                      this.response_info.VerifyResult =
                        response.data.Result.VerifyResult;
                    } else {
                      this.no_results = true;
                    }
                  })
                  .catch(() => {
                    this.loading = false;
                    this.searchComplete = true;
                    this.no_results = true;
                  });
              }
            });
        });
    },
  },
};
</script>
